import React     from 'react';
import PropTypes from 'prop-types';
import CamShowsFeatured from './CamShowsFeatured';

class CamShowsHeader extends React.PureComponent {
  render() {
    return (
      <div className='cam-shows__header'>
          <div className='cam-shows__header-wrapper'>
              <h1 className='cam-shows__header-title' dangerouslySetInnerHTML={{__html: this.props.getTranslation('header-title')}}></h1>
              <div className={'cam-shows__header-text' + (this.props.featuredShows.length === 0 ? ' cam-shows__header-text--full' : '')}>
              {this.props.getTranslation('header-subtitle')}
              </div>
          </div>

          {this.props.featuredShows.length > 0 && <CamShowsFeatured items={this.props.featuredShows} isMobile={this.props.isMobile} onCloseModal={this.props.onCloseModal}/>}
      </div>
    );
  }
}

CamShowsHeader.propTypes = {
  getTranslation: PropTypes.func,
  featuredShows:  PropTypes.array,
  isMobile:       PropTypes.bool,
  onCloseModal:   PropTypes.func,
};

export default CamShowsHeader;
